// extracted by mini-css-extract-plugin
export var chevron = "_jj-4";
export var chevronExpanded = "_jj-5";
export var row = "_jj-0";
export var rowBody = "_jj-6";
export var rowDescription = "_jj-7";
export var rowHeader = "_jj-1";
export var rowTitle = "_jj-2";
export var rowTitleComplete = "_jj-3";